import { FC, useEffect, useState } from "react";
import { Button as AntButton, Descriptions, Modal, Select } from 'antd';
import Radio from '../../../Radio';
import { useTranslation } from "react-i18next";
import { YN } from "../../../../models/common.api.model";
import useUtil from "../../../../hooks/useUtil";
import { IOption } from "../../../../models/common.model";
import { IEvaluationItem, IEvaluationItemBody, IEvaluationItemCreate } from "../../../../models/evaluationItem.model";
import useNotification from "../../../../hooks/useNotification";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  evaluationItem?: IEvaluationItem;
  onCreate: (body: IEvaluationItemCreate) => void;
  onUpdate: (evaluationItemCode: number, body: IEvaluationItemBody) => void;
};

const EvaluationItemModal: FC<IProps> = ({
  visible,
  setVisible,
  evaluationItem,
  onCreate,
  onUpdate,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { getDetailCodeOptions } = useUtil();

  const [evaluationItemName, setEvaluationItemName] = useState('');
  const [evaluationBrnCode, setEvaluationBrnCode] = useState<string>();
  const [memo, setMemo] = useState('');
  const [useYN, setUseYN] = useState<YN>('Y');

  useEffect(() => {
    setEvaluationItemName(evaluationItem?.evaluationItemName || '');
    setEvaluationBrnCode(evaluationItem?.evaluationBrnCode || undefined);
    setMemo(evaluationItem?.memo || '');
    setUseYN(evaluationItem?.useYN || 'Y');  
  }, [evaluationItem]);

  const onSubmit = () => {
    if (!evaluationItemName) {
      return infoNotification(t('program.criteria.message1'));
    }
    if (!evaluationBrnCode) {
      return infoNotification(t('program.criteria.2'));
    }
    if (evaluationItem) {
      onUpdate(
        evaluationItem.evaluationItemCode,
        {
          evaluationItemName,
          memo,
          useYN,
        },
      );
    } else {
      onCreate({
        evaluationItemName,
        evaluationBrnCode,
        memo,
        useYN,
      });
    }
    onClose();
  };

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      title={t('program.criteria.title2')}
      visible={visible}
      onCancel={onClose}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmit}
          >
            {t('common.button.save')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onClose}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <div className="comm-table__area rowType mt-0">
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label={t('program.criteria.column1')}>
            <input
              type="text"
              className="form-control input-text"
              value={evaluationItemName}
              onChange={(e) => setEvaluationItemName(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('program.criteria.1')}>
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={evaluationBrnCode}
              onChange={value => setEvaluationBrnCode(value)}
              disabled={!!evaluationItem}
            >
              {getDetailCodeOptions('GR0007')?.map((option: IOption) => (
                <Select.Option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label={t('program.criteria.column5')}>
            <input
              type="text"
              className="form-control input-text"
              value={memo}
              onChange={(e) => setMemo(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('program.criteria.column4')}>
            <Radio
              checked={useYN === 'Y'}
              onChange={() => setUseYN('Y')}
              text={t('common.option.yes')}
            />
            <Radio
              className="ml-4"
              checked={useYN === 'N'}
              onChange={() => setUseYN('N')}
              text={t('common.option.no')}
            />
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
};

export default EvaluationItemModal;